import { thirdparty_integration_video_id } from 'src/consts/resource';

const SectionContent = {
  topSection: {
    en: {
      poster: `${process.env.ASSETS_PREFIX}/products/products_pos_thirdparty_integration.png`,
      title: 'Third Party Delivery Integrations',
      description: `Chowbus POS provides third party delivery integration with over 45 delivery providers including all major marketplace partners such as Grubhub, Doordash, UberEats, Postmates, etc. This service will allow you to manage all of your third party menus, hours, prices, and sales in the same place at the same time. `,
      youtubeVideoId: thirdparty_integration_video_id.en,
    },
    zh: {
      poster: `${process.env.ASSETS_PREFIX}/products/products_pos_thirdparty_integration.png`,
      title: '第三方外卖平台集成',
      description: '集成近50家外卖平台，第三方外卖平台订单直接导入Chowbus POS，还可以统一管理菜单图片、价格及营业额。',
      youtubeVideoId: thirdparty_integration_video_id.zh,
    },
  },
  advances: {
    en: {
      title: `Chowbus Third Party Delivery Integrations bring multiple order platforms and POS systems together. Simplifying the order process, sending them straight to the POS system.`,
      subTitle: ``,
      featureList: [
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_thirdparty_integration_feature_1.png`,
          imageAlt: 'No More Tablet Hell',
          title: 'No More Tablet Hell',
          description:
            'Consolidate all your third party delivery platforms into one place and say goodbye to the wall of tablets.',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_thirdparty_integration_feature_2.png`,
          imageAlt: 'No More Missing or Incorrect Orders',
          title: 'No More Missing or Incorrect Orders',
          description:
            'Orders from the third party delivery platforms sent directly to the POS systems, which means accurate orders, every time.',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_thirdparty_integration_feature_3_0.png`,
          imageAlt: 'One Menu for All',
          title: 'One Menu for All',
          description:
            'Managing multiple menus and stock control has never been easier. Edit, snooze, and sync menus across all your channels in seconds.',
        },
      ],
    },
    zh: {
      title: `智能导入订单，简化接单流程`,
      subTitle: ``,
      featureList: [
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_thirdparty_integration_feature_1.png`,
          imageAlt: '无需繁杂的设备',
          title: '无需繁杂的设备',
          description: '所有第三方外卖平台订单直接导入Chowbus POS，无需多台设备分开管理',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_thirdparty_integration_feature_2.png`,
          imageAlt: '实时同步所有订单',
          title: '实时同步所有订单',
          description: '实时导入所有外卖订单，不再出现订单遗漏、订单延迟等问题',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_thirdparty_integration_feature_3.png`,
          imageAlt: '统一管理菜单',
          title: '统一管理菜单',
          description: '在Chowbus POS一站式管理所有外卖平台的菜单：图片、上下架、价格等',
        },
      ],
    },
  },

  features: {
    en: {
      title:
        'Chowbus Third Party Delivery Integrations allows you to manage all of your third-party menus, in the same place, at the same time, while reducing labor costs and order errors',
      items: [
        {
          layout: 'row',
          direction: 'normal',
          title: 'Reduce Labor Cost',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_thirdparty_integration_advance_1.png`,
          description: `Chowbus automates the flow of third-party orders to the POS systems. No more manual re-entry, tablet madness, or unnecessary delays. Minimizing room for error and freeing your staff to focus on your in-person guests.`,
        },

        {
          layout: 'row',
          direction: 'reverse',
          title: 'Increase your orders',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_thirdparty_integration_advance_2.png`,
          description:
            'Say goodbye to missed or delayed orders. Third-party orders will send it straight to Chowbus POS, and go right to the kitchen automatically. Chowbus third party integration can help you increase your orders and revenue in a flash.',
        },
        {
          layout: 'row',
          direction: 'normal',
          title: 'Manage all your third party menus in one place',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_thirdparty_integration_advance_3.png`,
          description: `Any changes you make to your Chowbus POS menu will automatically reflect on all of your third-party menus. Edit and update multiple menus with one click. Sync all orders with your stock management for a more accurate inventory.`,
        },
      ],
    },
    zh: {
      title: '最大程度自动化流程，减少人力投入',
      items: [
        {
          layout: 'row',
          direction: 'normal',
          title: '降低餐厅人工成本',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_thirdparty_integration_advance_1.png`,
          // description: `Chowbus第三方外卖平台集成，智能地将所有第三方外卖平台的订单自动导入POS系统中. 不再需要餐厅员工手动输入订单，没有多余的设备，更不会有订单延迟现象发生. 让您的员工专注在和顾客面对面的服务中，减少不必要的时间成本.`,
          items: [
            { desc: '餐厅无需投入多台设备接不同外卖平台的订单' },
            { desc: '店员无需手动录入各个外卖平台的订单至POS系统' },
          ],
        },
        {
          layout: 'row',
          direction: 'reverse',
          title: '增加出单效率',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_thirdparty_integration_advance_2.png`,
          // description: `使用Chowbus第三方外卖平台集成后，将不再出现遗失订单和订单延迟的情况. 所有第三方外卖平台的订单将会自动出现在POS系统中，并且直接送到后厨. 大大帮助您的餐厅有效增加更多的订单 .`,
          items: [
            { desc: '所有第三方外卖平台订单直接送厨，增加出餐效率' },
            { desc: '订单实时发送，避免订单遗漏、订单延迟等情况的出现' },
          ],
        },
        {
          layout: 'row',
          direction: 'normal',
          title: '统一管理外卖订单',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_thirdparty_integration_advance_3.png`,
          // description: `一键修改所有外卖平台的菜单和库存. 多个外卖平台均可在Chowbus POS平台上统一管理，效率极高.`,
          items: [
            { desc: '在Chowbus POS一站式管理所有外卖平台的菜单和库存，如餐品图片、价格、上下架等' },
            { desc: '统一管理所有外卖平台的订单和销售额，快速分析数据表现' },
          ],
        },
      ],
    },
  },

  customerVoiceInfos: [
    {
      img: `${process.env.ASSETS_PREFIX}/home/customervoice/customer-voice-xianghunan.jpeg`,
      productLine: 'Third-party Integration',
      desc: {
        zh: `更换餐厅收银系统是一件很头疼的事情, 但对Chowbus来说却一点不麻烦. 天天湘上的老板Zhichao说, “Chowbus POS的软件开发和硬件都非常先进. 而且整套系统是为中餐厅定制的, 所以我们的员工学习起来都非常容易上手. 我们从外卖开始就一直和Chowbus合作, 他们的服务很有耐心, 回复速度也非常快. 我不后悔选择Chowbus.”`,
        en: `Switching the POS system can be hectic. But not for Chowbus. Xiang’s Hunan kitchen‘s owner Zhichao said, “Chowbus POS utilizes the most advanced software and hardware features. Most importantly, it’s easy for restaurant staff to learn and use it. We’ve been partnering with Chowbus for a long time now, starting with delivery and now POS. I never regret a day that I chose Chowbus POS. They listen to and care about our needs and they act fast.” `,
      },
      restaurantName: { zh: '天天湘上', en: 'Xiang’s Hunan kitchen' },
      location: { zh: `波士顿`, en: 'Boston, MA' },
      link: '/business-types/chinese-restaurant/xiangs-hunan-kitchen',
    },
  ],
};

export default SectionContent;
